import React, { memo } from 'react';
import { CalendarGrid } from '../components/CalendarGrid';
import { ScheduleItem } from '../types/scheduleItem.types';
import { TimeScale } from '../types/calendar.types';

interface WorkWeekViewProps {
  currentDate: Date;
  items: ScheduleItem[];
  timeScale: TimeScale;
  onItemClick?: (item: ScheduleItem) => void;
  onItemDragStart?: (e: React.DragEvent, item: ScheduleItem) => void;
  onItemDragEnd?: () => void;
  onDrop?: (e: React.DragEvent, date: Date, time: Date) => void;
  onCreateClick?: (date: Date, time: Date) => void;
  allowDrag?: boolean;
  onOpenWorkOrder?: (invoiceDocId: number) => void;
}

export const WorkWeekView: React.FC<WorkWeekViewProps> = memo(({
  currentDate,
  items,
  timeScale,
  onItemClick,
  onItemDragStart,
  onItemDragEnd,
  onDrop,
  onCreateClick,
  allowDrag = true,
  onOpenWorkOrder,
}) => {
  return (
    <CalendarGrid
      viewType="workweek"
      currentDate={currentDate}
      items={items}
      timeScale={timeScale}
      onItemClick={onItemClick}
      onItemDragStart={onItemDragStart}
      onItemDragEnd={onItemDragEnd}
      onDrop={onDrop}
      onCreateClick={onCreateClick}
      allowDrag={allowDrag}
      onOpenWorkOrder={onOpenWorkOrder}
    />
  );
});

WorkWeekView.displayName = 'WorkWeekView';
